import React from 'react';
import { useSupabaseAuth } from '../../contexts/SupabaseAuthContext';
import { SmartLogin } from './SmartLogin';
import { useLocation } from 'wouter';

interface ProtectedRouteProps {
  children: React.ReactNode;
}

export const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ children }) => {
  const { isAuthenticated, loading } = useSupabaseAuth();
  const [location] = useLocation();

  console.log('[ProtectedRoute] loading:', loading, 'isAuthenticated:', isAuthenticated);

  if (loading) {
    console.log('[ProtectedRoute] Showing loading spinner');
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-purple-600"></div>
      </div>
    );
  }

  if (!isAuthenticated) {
    // Pass the current location so SmartLogin can redirect back after auth
    return <SmartLogin returnTo={location} />;
  }

  return <>{children}</>;
};